<template>
  <div>
    <v-container class="pa-0" fluid>
      <!-- <material-card icon="mdi-clipboard-text" inline :title="moduleID ? 'Edit Module' : 'Add Module'"> -->
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="2" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  {{moduleID ? 'Edit Module' : 'Add Module'}}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'teacherModules' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" lg="6">
                <v-textarea  label="Module Name" hide-details class="my-0 py-1" v-model="formdata.moduleName" :rules="moduleNameRules" :counter="200" required></v-textarea>
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete hide-details class="my-0 py-1"  v-model="formdata.class" :items="classData" item-text="name" item-value="id" label="Select Class Group" return-object :rules="classRules" @change="onClassGroupChange(formdata.class.id)"></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="6" v-if="getList.length > 0"><span id="abcd">Classes:</span><br>
              <v-chip-group column >
                <v-chip small color="accent"
                v-for='name in getList'
                :key="name"
                  >
                  {{ name }}
                </v-chip>
              </v-chip-group>
              </v-col>
              <!-- <v-col cols="12" lg="6" v-if="getList.length > 0"><b>Classes</b> :<br> {{ getList }}</v-col> -->
              <v-col cols="12" lg="6">
                <v-textarea hide-details class="my-0 py-1" clearable clear-icon="mdi-close-circle" name="input-7-1" rows="3" label="Enter description" v-model="formdata.description" hint="description"></v-textarea>
              </v-col>
              <v-col cols="12" lg="4">
                <h1>
                  <span class="warning--text my-0 py-1" hide-details
                    ><b>Upload Module Files/Links <span class="error--text">*</span></b></span
                  >
                </h1>
                <v-autocomplete hide-details :items="FileTypes" label="Select file type" v-model="selectedFileType" :change="changedSelect"></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="4">
                <label v-show="selectedFileType"  id="abcd" > Choose :</label><br>
                <v-radio-group v-model="radioGroup" v-if="selectedFileType" row>
                  <v-radio label="Upload File" class="font-weight-black ml-2" value="fileupload"></v-radio>
                  <v-radio label="Upload Link" class="font-weight-black " value="linkUpload"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="4" v-if="radioGroup && radioGroup == 'fileupload'">
                <v-file-input
                :messages="['(max file size allowed 20MB)']"
                  placeholder="Upload your documents"
                  v-model="dropFiles"
                  multiple
                  :accept="'.' + selectedFileType"
                  @input="uploadFileCheck(dropFiles)"
                  label="File input (use ctrl+select to add multiple files)"
                >
                  <template v-slot:selection="{ text, index }">
                    <v-chip small label outlined color="primary" close @click:close="deleteDropFile(index)">
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-col>
              <v-col cols="12" class="px-4" sm="4" v-if="radioGroup && radioGroup == 'linkUpload'">
                <v-row no-gutters>
                  <v-col cols="12" md="8">
                    <v-text-field class="mt-4 mr-2" label="File Link" hide-details v-model="fileLink"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-btn color="primary" class="ma-2 mt-6" @click="addLink">
                      <v-icon left>mdi-plus</v-icon>
                      Add Link
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <div class="inside" v-if="dropFiles.length || uploadedFiles.length">
                <v-col cols="12">
                  <h1>
                    <span class="warning--text"
                      ><b>Uploaded Files</b></span
                    >
                  </h1>
                  <div v-if="uploadedFiles.length">
                    <span v-for="(file, index) in uploadedFiles" :key="index">
                      <span v-if="!file.deletedAt">
                        <v-chip class="ma-2" outlined close color="primary" label @click:close="deleteUploadedFiles(index)">{{ file.name }} </v-chip>
                      </span>
                    </span>
                  </div>
                </v-col>
              </div>
              <div class="inside" v-if="uploadedLinks.length || fileLinksArray.length">
                <v-col cols="12" lg="6">
                  <h1>
                    <span class="warning--text"
                      ><b>Uploaded Links</b></span
                    >
                  </h1>
                  <div v-if="fileLinksArray.length">
                    <span v-for="(file, index) in fileLinksArray" :key="index">
                      <v-chip class="ma-2" outlined close color="primary" label @click:close="deleteFileLink(index)">{{ file.link }} </v-chip>
                    </span>
                  </div>
                  <div v-if="uploadedLinks.length">
                    <span v-for="(file, index) in uploadedLinks" :key="index">
                      <span v-if="!file.deletedAt">
                        <v-chip class="ma-2" outlined close color="primary" label @click:close="deleteUploadedLinks(index)">{{ file.key }} </v-chip>
                      </span>
                    </span>
                  </div>
                </v-col>
              </div>
              <v-col cols="12" >
                <v-card-actions class="d-flex justify-end">
                  <v-spacer />
                  <v-btn elevation="1" @click="onSubmit" color="primary">
                    <v-icon left> mdi-content-save </v-icon>
                    Save Module
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-card>
      <!-- </material-card> -->
    </v-container>
    <loading-icon :value="isLoading" />
  </div>
</template>

<script>
import constants from '@/utils/constants'
// import MaterialCard from '@/components/template/MaterialCard'
// import Utils from '@/utils'
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'OnlineClassList',
  props: ['moduleID'],
  // components: { MaterialCard },
  data () {
    return {
      data: [],
      valid: false,
      fileLink: null,
      dropFiles: [],
      fileLinksArray: [],
      classData: [],
      selectedFileType: null,
      radioGroup: null,
      FileTypes: ['PDF', 'PPT', 'DOCX', 'XLSX', 'mp4', 'JPEG', 'PNG', 'JPG', 'MP3'],
      formdata: {
        moduleName: '',
        class: '',
        description: ''
      },
      moduleNameRules: [v => !!v || 'Module Name is required', v => v.length <= 200 || 'Module Name must be less than 200 characters'],
      classRules: [v => !!v || 'Item is required'],
      uploadedFiles: [],
      uploadedLinks: [],
      isActive: null,
      isLoading: false,
      getList: {}
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {},
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    try {
      await this.getClassData()
      if (this.moduleID) {
        await this.getModuleData(this.moduleID)
      }
      // this.isWrite = Utils.helper.getIsWriteFun(this.$route)
      // this.isLoading = true
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    uploadFileCheck (data) {
      this.dropFiles = _.uniqBy(this.dropFiles, 'name')
    },
    deleteUploadedFiles (index) {
      this.uploadedFiles[index].deletedAt = moment().format('YYYY-MM-DD h:mm:ss')
    },
    deleteUploadedLinks (index) {
      this.uploadedLinks[index].deletedAt = moment().format('YYYY-MM-DD h:mm:ss')
    },
    getModuleData: async function (id) {
      try {
        this.isLoading = true
        let result = await http.get(`${constants.API_URL}/api/teacher-training/module/get/${id}`)
        this.isLoading = false
        this.formdata.moduleName = result.data.name
        this.formdata.class = result.data.studentClassGroup
        this.formdata.description = result.data.description
        this.isActive = result.data.isActive
        _.map(result.data.trainingModuleFileMaps, d => {
          d.isLink ? this.uploadedLinks.push(d) : this.uploadedFiles.push(d)
        })
        await this.getClassList(result.data.studentClassGroup.id)
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    changedSelect () {
      this.selectedFileType = null
      this.radioGroup = null
    },
    addLink () {
      if (this.fileLink) {
        let isValid = this.validateLink(this.fileLink)
        if (!isValid) {
          this.fileLink = null
          return this.errMsg('Please Add valid URL')
        }
        _.find(this.fileLinksArray, { link: this.fileLink })
        if (_.find(this.fileLinksArray, { link: this.fileLink })) {
          return this.errMsg('Link already added')
        }
        this.fileLinksArray.push({
          type: this.selectedFileType.toLowerCase(),
          link: this.fileLink
        })
        this.fileLink = null
      }
    },
    validateLink (url) {
      var pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      ) // fragment locator
      return !!pattern.test(url)
    },
    deleteFileLink (index) {
      this.fileLinksArray.splice(index, 1)
    },
    deleteDropFile (index) {
      this.dropFiles.splice(index, 1)
    },
    onSubmit: async function () {
      try {
        this.formdata.moduleName = this.formdata.moduleName.trim()
        if (!this.valid) {
          return this.errMsg('Please provide valid data!')
        }
        if (_.isEmpty(this.dropFiles) && _.isEmpty(this.fileLinksArray) && !this.moduleID) {
          return this.errMsg('Please upload files or provide file link')
        }
        let form = new FormData()
        form.append('name', this.formdata.moduleName)
        form.append('classID', this.formdata.class.id)
        form.append('description', this.formdata.description)
        form.append('isLink', !_.isEmpty(this.fileLinksArray))
        if (!_.isEmpty(this.fileLinksArray)) {
          form.append('links', JSON.stringify(this.fileLinksArray))
        }
        if (!_.isEmpty(this.dropFiles)) {
          for (let i = 0; i < this.dropFiles.length; i++) {
            form.append('files', this.dropFiles[i])
          }
        }
        let transection
        let message = ''
        if (this.moduleID) {
          let uploadedFilesAndLinks = []
          if (!_.isEmpty(this.uploadedFiles)) {
            _.map(this.uploadedFiles, val => {
              uploadedFilesAndLinks.push(val)
            })
          }
          if (!_.isEmpty(this.uploadedLinks)) {
            _.map(this.uploadedLinks, val => {
              uploadedFilesAndLinks.push(val)
            })
          }
          if (
            !_.isEmpty(
              _.filter(uploadedFilesAndLinks, d => {
                return _.isNull(d.deletedAt)
              })
            )
          ) {
            form.append('trainingModuleFileMaps', JSON.stringify(uploadedFilesAndLinks))
          } else {
            if (_.isEmpty(this.dropFiles) && _.isEmpty(this.fileLinksArray)) {
              return this.errMsg('Please upload files or provide file link')
            }
          }

          form.append('id', this.moduleID)
          transection = http.post(`${constants.API_URL}/api/teacher-training/module/update`, form)
          message = `Module updated successfully!`
        } else {
          transection = http.post(`${constants.API_URL}/api/teacher-training/module/create`, form)
          message = `Module added successfully!`
        }
        this.isLoading = true
        await transection
        this.isLoading = false

        this.$buefy.dialog.alert({
          message: message,
          type: 'is-success'
        })
        this.$router.push({ name: 'teacherModules' })
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getClassData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/student/getclass-group`)
        this.isLoading = false
        data = _.filter(data, e => {
          return e.type === constants.ClassGroupTypes.teacherTraining && e.isActive === true
        })
        this.classData = data
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
          } else {
            this.franchiseeID = ''
          }
          if (this.academicYear) {
            this.academicYearID = this.academicYear.id
          } else {
            this.academicYearID = ''
          }
          this.inProgress = false
        }
      } finally {
        this.inProgress = false
      }
    },
    onClassGroupChange: async function (ID) {
      await this.getClassList(ID)
    },
    getClassList: async function (classGroupID) {
      this.hasClicked = true
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/student/get-selected-classgroup-mapping/${classGroupID}`)
        this.mappingData = data
        let selectedClassObj = []
        if (this.mappingData) {
          const objectArray = Object.entries(this.mappingData)
          objectArray.forEach(([key, value]) => {
            value.studentClasses.map(function (k) {
              selectedClassObj.push(k.name)
            })
          })
          // this.getList = selectedClassObj.join(', ')
          this.getList = selectedClassObj
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Class Group Mapping: ${errorMessage}`)
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style scoped>
#abcd{
  color:rgba(0,0,0,.6) ;
  font-size: 16px;
}
</style>
